import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import moment from 'moment'
import clsx from 'clsx'
import SubmitButton from 'form-module/ui/inputs/SubmitButton'
import Input from 'form-module/ui/inputs/Input'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useReloadCameras } from '../../../../cameras/core/useCameras'
import CameraToggleItem from './CameraToggleItem'
import useOwnedSharedCameras from '../../../core/useOwnedSharedCameras'
import PrimaryButton from 'shared-module/new-components/buttons/PrimaryButton'
import { useDispatch } from 'react-redux'
import cameraSharingActions from '../../../core/CameraSharingActions'
import formatFormData from './GuestFormHelper'
import FormDisclaimer from './Disclamers/FormDisclaimer'
import CameraDisclaimer from './Disclamers/CameraDisclaimer'
import WarningBox from '../WarningBox/WarningBox'
import cameraSharingApi from '../../../api/cameraSharingApi'
import messageActions from 'shared-module/message/messageActions'
import useConfirmationDialogActions from 'shared-module/components/confirmation/useConfirmationDialogActions'
import ConfirmationDialog from 'shared-module/components/confirmation/ConfirmationDialog'
import useLanguage from 'shared-module/components/language/useLanguage'
import { useEffect, useState } from 'react'
import AlertBox from '../AlertBox/AlertBox'
import CircleAlert from 'assets/icons/CircleAlert'
import CameraSharingIcon from 'assets/icons/navigation/cameraSharingIcon'
import SecondaryButton from 'shared-module/new-components/buttons/SecondaryButton'
import useUser from 'user-module/user/core/useUser'
import ShareHistorySelect from './ShareHistorySelect'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/de'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import CButton from 'storybook-component-module/src/components/buttons/CButton'
import MuiTooltip from '@material-ui/core/Tooltip'
import InfoRoundedIcon from '@material-ui/icons/InfoRounded'
import withStyles from '@material-ui/core/styles/withStyles'
import { alpha } from '@mui/system'

const Tooltip = withStyles((theme) => ({
  tooltip: {
    boxShadow: theme.shadows[1],
    fontSize: '1em',
  },
}))(MuiTooltip)
const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    justifyContent: 'center',
    border: '1px solid #464444',
    backgroundColor: '#0E0B0B',
  },
  container: {
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.background.paper} ${theme.palette.background.default}`,
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.background.default,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.background.paper,
    },
  },
  title: {
    fontFamily: 'Oswald-regular',
    fontSize: '26px',
    marginTop: '12px',
    fontWeight: 500,
    lineHeight: '29.9px',
    textAlign: 'center',
    color: '#F5F4F4',

  },
  paragraph: {
    fontFamily: theme.typography.body1?.fontFamily,
    fontSize: '16px',
    margin: '20px 36px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    color: '#FFFFFF',
    [theme.breakpoints.down('md')]: {
      margin: '20px 12px',
    },
  },
  image: {
    height: 'auto',
    marginTop: '21px',
  },
  formTitle: {
    color: theme.palette.text.secondary,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '700',
  },
  form: {
    marginTop: '40px',
  },
  titleInfo: {
    fontFamily: 'Oswald-regular',
    fontSize: '21px',
    lineHeight: '31.5px',
    fontWeight: '500',
  },
  infoIcon: {
    color: alpha(theme.palette.secondary.main, 0.7),
    fontSize: '1em',
    display: 'inline-block',
    marginLeft: '97%',
    marginBottom: '2px',
    marginTop: '8px',
  },
}))

const GuestForm = ({ isUserClub, selectedGuest, setSelectedGuest, hasGuest, className }) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const user = useUser()
  const [maxSharingCam, setMaxSharingCam] = useState(false)
  const [historyControl, setHistoryControl] = useState(0)
  const [initialHistoryControl, setInitialHistoryControl] = useState(null)
  const [value, setValue] = useState(null)
  const [selectedGuestInitialvalue, setSelectedGuestInitialvalue] = useState(null)
  const [showTooltip, setShowTooltip] = useState(false)
  const [showTooltipName, setShowTooltipName] = useState(false)
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()
  const isMobileResolution = useMediaQuery(theme.breakpoints.down('sm'))
  const cameras = useReloadCameras()
  const dialogActions = useConfirmationDialogActions()
  const sendInviteDialogActions = useConfirmationDialogActions()
  const learnMoreDialogActions = useConfirmationDialogActions()
  const ownedSharedCameras = useOwnedSharedCameras()
  const updatedGuest = ownedSharedCameras.filter((ownedSharedCamera) => ownedSharedCamera?.guestUserEmail === selectedGuest?.guestUserEmail)[0]
  const language = useLanguage()
  const isFrench = language === 'fr'
  const breakpoint = useMediaQuery(theme.breakpoints.down('xs'))

  useEffect(() => {
    setMaxSharingCam(false)
  }, [selectedGuest])
  useEffect(() => {
    const photoHistoryDate = selectedGuest?.photoHistoryLimit?.substring(0, 10)
    setValue(selectedGuest?.photoHistoryLimit ? dayjs(photoHistoryDate) : dayjs(new Date()))
  }, [selectedGuest])
  useEffect(() => {
    setSelectedGuestInitialvalue(updatedGuest)
    setSelectedGuest(updatedGuest)
  }, [selectedGuest, updatedGuest])
  useEffect(() => {
    setHistoryControl(0)
    setInitialHistoryControl(0)
    if (selectedGuest?.photoHistoryLimit) {
      const Now = new Date()
      const selectedPhotoLimit = selectedGuest?.photoHistoryLimit
      const aYearFromNow = new Date()
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() - 1)
      const d = new Date() // today!
      d.setDate(d.getDate() - 1)
      if (d && selectedPhotoLimit < d.toISOString()) {
        setHistoryControl(1)
        setInitialHistoryControl(1)
      } else if (selectedPhotoLimit >= d.toISOString()) {
        setHistoryControl(2)
        setInitialHistoryControl(2)
      }
      if (selectedPhotoLimit < aYearFromNow.toISOString()) {
        setHistoryControl(0)
        setInitialHistoryControl(0)
      }
    }
  }, [selectedGuest, updatedGuest])

  const handleTooltipOpening = () => {
    if (breakpoint) {
      setShowTooltip(true)
      setTimeout(() => setShowTooltip(false), 5000)
    }
  }

  const handleTooltipNameOpening = () => {
    if (breakpoint) {
      setShowTooltipName(true)
      setTimeout(() => setShowTooltipName(false), 5000)
    }
  }

  const initialValue = selectedGuest
    ? { name: selectedGuest.guestUsername, email: selectedGuest.guestUserEmail, cameraIds: selectedGuest.sharedCameras.map(camera => camera.cameraId) }
    : { name: '', email: '', cameraIds: [] }

  const GuestFormSchema = Yup.object().shape({
    name: Yup.string()
      .required(t('input.name_required'))
      .matches(/^[a-zA-Z0-9 ]*$/, 'Name can only contain letters and numbers')
      .max(20, 'Name can be at most 20 characters long'),
    email: Yup.string()
      .required(t('input.email_required'))
      .email(t('input.email_invalid')),
  })

  const handleSubmit = (values, { resetForm }) => {
    dispatch(cameraSharingActions.share(formatFormData({ ...values, value, historyControl })))
      .then(() => {
        resetForm()
      })
  }

  const formatDate = (data) => {
    const date = new Date(data)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // January is 0!
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  const aYearFromNow = new Date()
  aYearFromNow.setFullYear(aYearFromNow.getFullYear() - 1)
  const locale = user?.dateFormat === 'mdy' ? 'en' : 'en-gb'

  const removeAccess = () => {
    cameraSharingApi.deleteAccess({ cameraIds: [...selectedGuest?.sharedCameras.map(camera => camera.cameraId)], guestEmail: selectedGuest.guestUserEmail })
      .then(() => {
        dispatch(messageActions.showSuccess(t('camera_sharing.guest_removed')))
        dispatch(cameraSharingActions.fetchOwnedSharedCameras())
        setSelectedGuest(null)
        dialogActions.close()
      })
      .catch(() => dispatch(messageActions.showError()))
  }
  const compareArrays = (sharedCameras, cameraIds) => {
    return sharedCameras.map(x => cameraIds?.includes(x))
  }

  const disableButton = (selectedGuestInitialvalue, values) => {
    const compareDate = () => {
      if (initialHistoryControl === 1) {
        const Now = new Date()
        const date = new Date(value)
        if (selectedGuestInitialvalue?.photoHistoryLimit && value) { return selectedGuestInitialvalue?.photoHistoryLimit === moment.utc(moment(date).format('DD/MM/YYYY'), 'DD/MM/YYYY').utcOffset(0).hours(0).minutes(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' } else if (!value) return true
        else if (!selectedGuestInitialvalue?.photoHistoryLimit) return false
      } else return true
    }
    const sharedCameras = selectedGuestInitialvalue?.sharedCameras?.map(x => x.cameraId)
    const date = new Date(value)
    const cameraIds = values?.cameraIds
    return selectedGuestInitialvalue?.guestUserEmail === values?.email && selectedGuestInitialvalue?.guestUsername === values?.name && selectedGuestInitialvalue?.sharedCameras.length === values?.cameraIds?.length && !compareArrays(sharedCameras, cameraIds).includes(false) && initialHistoryControl === historyControl && compareDate()
  }

  if (!isUserClub) {
    return (
      <Grid container style={{ paddingTop: isMobileResolution ? '0px' : !hasGuest ? '20px' : '50px' }}>
        <Grid container alignItems="center">
          <Box pr={1} mt={1}><CameraSharingIcon /></Box>
          <Box><div className={classes.titleInfo}>{ t('camera_sharing.renew_membership.title') }</div></Box>
        </Grid>
        <Grid container alignItems="center" style={{ fontSize: '16px' }}>
          <Box mt={isMobileResolution ? 2 : 6}>
            { !hasGuest
              ? (
                <div>
                  { t('camera_sharing.renew_membership.paragraph_one_join') }
                </div>
                )
              : (
                <div>
                  { t('camera_sharing.renew_membership.paragraph_one_1') }{ <sup style={{ fontSize: 7 }}>{ t('camera_sharing.renew_membership.paragraph_one_3') }</sup> }{ t('camera_sharing.renew_membership.paragraph_one_2') }
                </div>
                ) }
          </Box>
          <Box mt={3}>
            <div>
              { t('camera_sharing.renew_membership.paragraph_two') }
            </div>
          </Box>
          <Box mt={3}>
            <div>
              &#9989; { t('camera_sharing.renew_membership.accessible_title') }
              <ul>
                <li>{ t('camera_sharing.renew_membership.accessible_list.list1') }</li>
                <li>{ t('camera_sharing.renew_membership.accessible_list.list2') }</li>
                <li>{ t('camera_sharing.renew_membership.accessible_list.list3') }{ i18n.language === 'fr' && <sup style={{ fontSize: 7 }}>MC</sup> }</li>
                <li>{ t('camera_sharing.renew_membership.accessible_list.list4') }</li>
                <li>{ t('camera_sharing.renew_membership.accessible_list.list5') }</li>
              </ul>
            </div>
          </Box>
          <Box mt={1}>
            <div>
              &#x1F512; { t('camera_sharing.renew_membership.inaccessible_title') }
              <ul>
                <li>{ t('camera_sharing.renew_membership.inaccessible_list.list1') }</li>
                <li>{ t('camera_sharing.renew_membership.inaccessible_list.list2') }</li>
                <li>{ t('camera_sharing.renew_membership.inaccessible_list.list3') }</li>
                <li>{ t('camera_sharing.renew_membership.inaccessible_list.list4') }</li>
                <li>{ t('camera_sharing.renew_membership.inaccessible_list.list5') }</li>
              </ul>
            </div>
          </Box>
        </Grid>
        <Box mt={isMobileResolution ? 2 : 3}>
          <SecondaryButton
            onClick={() => {
              history.push('/membership')
            }}
          >
            { !hasGuest ? t('camera_sharing.renew_membership.button_join') : t('camera_sharing.renew_membership.button') }
          </SecondaryButton>
        </Box>
      </Grid>
    )
  }
  return (
    <Box ml={isMobileResolution ? undefined : '56px'} mr={isMobileResolution ? undefined : '43px'} mt="24px" textAlign="left">
      <div data-testid="planDescriptor" className={classes.formTitle}>{ selectedGuest ? t('camera_sharing.edit_guest') : t('camera_sharing.add_guest') }</div>
      { selectedGuest && selectedGuest?.status === 'pending' &&
        (
          <WarningBox
            subText={`${t('camera_sharing.expires_date')}${formatDate(selectedGuest?.expiresAt)}`}
            text={t('camera_sharing.pending_status')}
          />
        ) }
      <Formik
        initialValues={initialValue}
        validationSchema={GuestFormSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        { ({ errors, touched, values, setFieldValue, resetForm }) => {
          return (
            <Form>
              <Field name="name">
                { ({ field }) => (
                  <div className={classes.form}>
                    <text onMouseEnter={() => setShowTooltipName(true)} onMouseLeave={() => setShowTooltipName(false)} onTouchStart={handleTooltipNameOpening}>
                      <Tooltip open={showTooltipName} title={t('input.tooltip_name')} arrow className={classes.infoIcon}>
                        <InfoRoundedIcon />
                      </Tooltip>
                    </text>
                    <Input
                      required
                      style={{ fontSize: '16px', fontFamily: 'ibm-plex-sans-regular' }}
                      name="name"
                      label={t('input.name')}
                      showErrorIcon
                      disabled={selectedGuest?.status === 'pending' || user?.isReadOnlyProfile}
                      {...field}
                    />
                  </div>
                ) }
              </Field>
              <Field name="email">
                { ({ field }) => (
                  <div>
                    { !selectedGuest && (
                      <text onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} onTouchStart={handleTooltipOpening}>
                        <Tooltip open={showTooltip} title={t('input.tooltip_email')} arrow className={classes.infoIcon}>
                          <InfoRoundedIcon />
                        </Tooltip>
                      </text>
                    ) }
                    <Input
                      required
                      name="email"
                      label={t('input.email')}
                      style={selectedGuest ? { marginBottom: '17px', marginTop: '24px', fontSize: '16px', fontFamily: 'ibm-plex-sans-regular' } : { marginBottom: '17px', fontSize: '16px', fontFamily: 'ibm-plex-sans-regular' }}
                      showErrorIcon
                      disabled={selectedGuest?.status === 'pending' || !!selectedGuest || user.isReadOnlyProfile}
                      {...field}
                    />
                  </div>
                ) }
              </Field>
              <ShareHistorySelect disabled={selectedGuest?.status === 'pending' || user?.isReadOnlyProfile} historyControl={historyControl} setHistoryControl={setHistoryControl} />
              { historyControl === 1 && (
                <LocalizationProvider adapterLocale={locale} dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled={selectedGuest?.status === 'pending' || user?.isReadOnlyProfile}
                    minDate={dayjs(aYearFromNow)}
                    maxDate={dayjs(new Date())}
                    label={t('camera_sharing.start_date')}
                    value={value}
                    onChange={(newValue) => {
                      setValue(newValue)
                    }}
                    sx={{
                      '&.Mui-disabled': {
                        color: 'red !important',
                      },
                      width: '100%',
                      '& .MuiSvgIcon-root': {
                        color: '#464444 !important',
                      },
                      '&:hover .MuiOutlinedInput-roo.Mui-error .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #F5F4F4 !important',
                      },
                      '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #464444 !important',
                      },
                      'label.Mui-error ': {
                        color: '#F5F4F4 !important',
                        marginTop: '-2px',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #464444',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #F5F4F4',
                      },
                      '& .MuiInputLabel-outlined': {
                        color: '#F5F4F4',
                        marginTop: '-2px',
                      },
                      '& label.Mui-focused': {
                        color: '#F5F4F4',
                        marginTop: '-2px',
                      },
                      '& label.Mui-error': {
                        color: theme.palette.text.secondary,
                      },
                      '&:hover .MuiOutlinedInput-root': {
                        border: 'none',
                      },
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #F89021',
                      },
                      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        border: '1.5px solid #F5F4F4',
                        color: '#F5F4F4',
                      },
                      '& .MuiOutlinedInput-root': {
                        color: '#F5F4F4',
                        border: 'none',
                        '& .Mui-focused fieldset': {
                          border: '1.5px solid #F5F4F4',
                        },
                      },
                      '& .MuiFormHelperText-root.Mui-error': {
                        color: theme.palette.status?.error,
                        margin: '0 !important',
                      },
                      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        opacity: 0.5,
                        border: '1.5px solid rgba(255, 255, 255, 0.5)',
                        color: 'rgba(255, 255, 255, 0.5) !important',
                        WebkitTextFillColor: 'unset',

                      },
                      '&:hover .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        opacity: 0.5,
                        border: '1.5px solid rgba(255, 255, 255, 0.5)',
                        color: 'rgba(255, 255, 255, 0.5) !important',
                        WebkitTextFillColor: 'unset',

                      },
                      '& .MuiInputBase-root.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.5) !important',
                        WebkitTextFillColor: 'unset',
                      },
                      'input.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.5) !important',
                        WebkitTextFillColor: 'unset',
                      },
                      'label.Mui-disabled ': {
                        color: 'rgba(255, 255, 255, 0.5) !important',
                        marginTop: '-2px',

                      },
                    }}
                    slotProps={{
                      month: {
                        sx: {
                          '&.MuiPickersMonth-root.Mui-selected': {
                            backgroundColor: '#F89021',
                            color: 'black',
                          },
                        },
                      },
                      day: {
                        sx: {
                          '&.MuiPickersDay-root': {
                            color: '#D3CFCF',
                          },
                          '&.MuiPickersDay-root.Mui-selected': {
                            backgroundColor: '#F89021',
                            color: 'black',
                          },
                        },
                      },
                      layout: {
                        sx: {
                          '& .MuiSvgIcon-root': {
                            color: '#D3CFCF !important',
                          },

                          '.MuiPickersCalendarHeader-root': {
                            color: '#D3CFCF',
                          },
                          '.MuiPickersYear-yearButton.Mui-selected': {
                            backgroundColor: '#F89021 !important',
                            color: 'black',
                          },
                          '.MuiDayCalendar-weekDayLabel': {
                            color: '#D3CFCF',
                          },
                          '.MuiPickersCalendarHeader-label': {
                            color: '#D3CFCF',
                          },
                          '.MuiPickersCalendarHeader-switchViewButton': {
                            color: '#D3CFCF',
                          },

                          color: '#D3CFCF',
                          borderRadius: '2px',
                          border: 'none',
                          backgroundColor: '#313030',

                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              ) }
              <Box mb="24px">
                <CameraDisclaimer cameraIds={values.cameraIds} cameras={cameras} />
              </Box>
              <Box maxHeight="350px" mb="50px" overflowY="auto" className={classes.container}>
                { cameras?.map((camera) => camera.status?.lastUpdate !== undefined && camera.isCellular && (
                  <CameraToggleItem
                    value={value}
                    historyControl={historyControl}
                    camera={camera}
                    setMaxSharingCam={setMaxSharingCam}
                    setFieldValue={setFieldValue}
                    cameraIds={values.cameraIds}
                    formValues={values}
                    disabled={selectedGuest?.status === 'pending' || user?.isReadOnlyProfile}
                    editable={selectedGuest?.status === 'accepted'}
                  />
                )) }
              </Box>

              { maxSharingCam && (<AlertBox text={t('camera_sharing.max_guests')} icon={CircleAlert} style={{ width: '100%', marginBottom: '26px', marginTop: '26px' }} />) }
              <Box>
                { !!selectedGuest && (
                  <Grid container direction="row-reverse" alignItems="flex-end" style={{ paddingRight: 0 }}>
                    <Grid item xs={isMobileResolution ? 12 : 4}>
                      <CButton
                        color="primary"
                        variety="primary"
                        type="button"
                        onClick={() => dispatch(cameraSharingActions.edit(formatFormData({ ...values, value, historyControl, selectedGuestPhotoHistoryLimit: selectedGuest?.photoHistoryLimit }))).then(() => {
                          setSelectedGuestInitialvalue(updatedGuest)
                        })}
                        disabled={selectedGuest?.status === 'pending' || user?.isReadOnlyProfile || disableButton(selectedGuestInitialvalue, values)}
                        style={isMobileResolution ? { width: '100%', marginBottom: 8 } : { width: '100%', marginLeft: 8 }}
                      >
                        { t('button.save') }
                      </CButton>
                    </Grid>
                    <Grid item xs={isMobileResolution ? 12 : 6}>
                      <PrimaryButton color="primary" variant="outlined" style={{ width: '100%' }} onClick={dialogActions.open}>
                        { t('camera_sharing.remove_guest') }
                      </PrimaryButton>
                    </Grid>
                  </Grid>
                ) }
                { isMobileResolution
                  ? (
                      !selectedGuest && (
                        <Grid container justifyContent="flex-end">
                          <Grid item xs={12}>
                            <SubmitButton
                              color="primary"
                              variety="primary"
                              type="button"
                              onClick={sendInviteDialogActions.open} // Open the dialog instead of directly submitting the form
                              disabled={values.cameraIds.length === 0 || user.isReadOnlyProfile}
                              style={{ width: '100%' }}
                            >
                              { t('camera_sharing.send_invite') }
                            </SubmitButton>
                          </Grid>
                          <Grid item xs={12}>
                            <PrimaryButton color="primary" variant="outlined" style={{ width: '100%', marginTop: '24px' }} onClick={learnMoreDialogActions.open}>
                              { t('camera_sharing.learn_more') }
                            </PrimaryButton>
                          </Grid>
                        </Grid>
                      )
                    )
                  : !selectedGuest && (
                    <Grid container justifyContent="flex-end">
                      <Grid item xs={isFrench ? 6 : 4} style={{ paddingRight: '8px' }}>
                        <PrimaryButton color="primary" variant="outlined" style={{ width: '100%' }} onClick={learnMoreDialogActions.open}>
                          { t('camera_sharing.learn_more') }
                        </PrimaryButton>
                      </Grid>
                      <Grid item xs={4}>
                        <SubmitButton
                          color="primary"
                          variety="primary"
                          disabled={values.cameraIds.length === 0 || user.isReadOnlyProfile}
                          type="button"
                          onClick={sendInviteDialogActions.open} // Open the dialog instead of directly submitting the form

                          style={{ width: '100%' }}
                        >
                          { t('camera_sharing.send_invite') }
                        </SubmitButton>
                      </Grid>
                    </Grid>
                    ) }
                <ConfirmationDialog
                  isNewUi={false}
                  open={sendInviteDialogActions.isOpen}
                  title={t('camera_sharing.confirmation_invite.title')}
                  text={t('camera_sharing.confirmation_invite.message')}
                  onConfirm={() => {
                    // Submit the form when the "Confirm" button is clicked
                    dispatch(cameraSharingActions.share(formatFormData({ ...values, value, historyControl })))
                      .then(() => {
                        resetForm()
                      })
                    sendInviteDialogActions.close()
                  }}
                  onCancel={sendInviteDialogActions.close}
                  confirmText={t('camera_sharing.confirmation_invite.cta_button_send_invite')}
                  cancelText={t('camera_sharing.confirmation_invite.cta_button_cancel')}
                />
              </Box>
            </Form>
          )
        } }
      </Formik>

      <ConfirmationDialog
        isNewUi={false}
        open={dialogActions.isOpen}
        title={t('camera_sharing.confirmation.title')}
        text={t('camera_sharing.confirmation.text')}
        onConfirm={removeAccess}
        onCancel={dialogActions.close}
        confirmText={t('button.confirm')}
        cancelText={t('button.cancel')}
      />
      <ConfirmationDialog
        isNewUi={false}
        open={learnMoreDialogActions.isOpen}
        title={t('camera_sharing.page_title')}
        text={(
          <Grid container alignItems="center" style={{ fontSize: '14px' }}>
            <Box mt={isMobileResolution ? 2 : 6}>
              <div>
                { t('camera_sharing.renew_membership.paragraph_one') }
              </div>
            </Box>
            <Box mt={3}>
              <div>
                { t('camera_sharing.renew_membership.paragraph_two') }
              </div>
            </Box>
            <Box mt={3}>
              <div>
                &#9989; { t('camera_sharing.renew_membership.accessible_title') }
                <ul>
                  <li>{ t('camera_sharing.renew_membership.accessible_list.list1') }</li>
                  <li>{ t('camera_sharing.renew_membership.accessible_list.list2') }</li>
                  <li>{ t('camera_sharing.renew_membership.accessible_list.list3') }{ i18n.language === 'fr' && <sup style={{ fontSize: 7 }}>MC</sup> }</li>
                  <li>{ t('camera_sharing.renew_membership.accessible_list.list4') }</li>
                </ul>
              </div>
            </Box>
            <Box mt={1}>
              <div>
                &#x1F512; { t('camera_sharing.renew_membership.inaccessible_title') }
                <ul>
                  <li>{ t('camera_sharing.renew_membership.inaccessible_list.list1') }</li>
                  <li>{ t('camera_sharing.renew_membership.inaccessible_list.list2') }</li>
                  <li>{ t('camera_sharing.renew_membership.inaccessible_list.list3') }</li>
                  <li>{ t('camera_sharing.renew_membership.inaccessible_list.list4') }</li>
                  <li>{ t('camera_sharing.renew_membership.inaccessible_list.list5') }</li>
                </ul>
              </div>
            </Box>
            <Box mt={1}>
              <FormDisclaimer />
            </Box>
          </Grid>
        )}
        onConfirm={learnMoreDialogActions.close} // Close the dialog when the button is clicked
        confirmText={t('button.close')} // Change the button text to "Close"
      />
    </Box>
  )
}

export default GuestForm
